import { IconButton, styled, svgIconClasses } from '@mui/material';

const OutlinedIconButton = styled(IconButton)(({ theme }) => ({
    width: 32,
    height: 32,
    p: theme.spacing(0.5),
    color: theme.palette.primary.light,
    border: `1px solid ${ theme.palette.divider }`,
    [`&:hover`]: {
        borderColor: theme.palette.inputBorder
    },

    [`& .${ svgIconClasses.root }`]: {
        fontSize: 16
    }
}));

export default OutlinedIconButton;
